import httpRequest from 'httpRequest'
import {
    POSVariantGroup,
    VariantGroupContract,
    VariantGroupSlimModel,
} from 'models'

const VARIANT_PREFIX = '/company/variants'

const variantService = {
    getVariants: () => {
        return httpRequest.get<VariantGroupContract[]>(VARIANT_PREFIX)
    },
    getVariantLookupList: () => {
        return httpRequest.get<VariantGroupSlimModel[]>(
            `${VARIANT_PREFIX}/lookup-list`,
        )
    },
    getVariantForPOS: () => {
        return httpRequest.get<POSVariantGroup[]>(`${VARIANT_PREFIX}/pos`)
    },
    getVariantByID: (vID: string) => {
        return httpRequest.get<VariantGroupContract>(`${VARIANT_PREFIX}/${vID}`)
    },
    createVariant: (payload: VariantGroupContract) => {
        return httpRequest.post<VariantGroupContract>(
            `${VARIANT_PREFIX}`,
            payload,
        )
    },
    updateVariant: (vID: string, payload: VariantGroupContract) => {
        return httpRequest.put<VariantGroupContract>(
            `${VARIANT_PREFIX}/${vID}`,
            payload,
        )
    },
    deleteVariants: (variantIDs: string[]) => {
        return httpRequest.delete(`${VARIANT_PREFIX}`, {
            params: {
                variantIDs,
            },
        })
    },
    importVariant: (formData: FormData) =>
        httpRequest.post(`${VARIANT_PREFIX}/import`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        }),
}

export default variantService
